{
  "agb-dialog": {
    "text": {
      "agb": "General Terms and Conditions"
    },
    "buttons": {
      "close": "Close"
    }
  }
}
